import { combineReducers } from "redux";

import advancedSearchFilteringReducer from "app/pages/sales-intelligence/modules/advanced-search-filtering/store/reducer";
import { aiAgentReducer } from "app/pages/sales-intelligence/modules/ai-agent/store";
import appsSearchReducer from "app/pages/sales-intelligence/modules/apps-search/store/reducer";
import companyAnalysisReducer from "app/pages/sales-intelligence/modules/company-analysis/store/reducer";
import crmEnrichmentReducer from "app/pages/sales-intelligence/modules/crm-enrichment/store/reducer";
import crmExportReducer from "app/pages/sales-intelligence/modules/crm-export/store/reducer";
import { myListsReducer } from "app/pages/sales-intelligence/modules/enrichment/store/reducers/enrichment";
import leadsSearchReducer from "app/pages/sales-intelligence/modules/leads-search/store/reducer";
import { leadsSearchFiltersReducer } from "app/pages/sales-intelligence/modules/leads-search-filters";
import { quotaReducer } from "app/pages/sales-intelligence/modules/quota/store";
import { teamsReducer } from "app/pages/sales-intelligence/modules/teams/store/reducer";
import type { SalesIntelligenceState } from "app/pages/sales-intelligence/types/state/store";

import accountOverviewReducer from "../sub-modules/account-overview/store/reducer";
import advancedSearchReducer from "../sub-modules/advanced-search/store/reducer";
import assignToUsersReducer from "../sub-modules/assign-to-users/store/reducer";
import commonReducer from "../sub-modules/common/store/reducer";
import contactsExportReducer from "../sub-modules/contacts-tab/store/reducer";
import contactsTabReducer from "../sub-modules/contacts-tab/store/reducer/reducer";
import intentReducer from "../sub-modules/intent/store/management/reducers/reducer";
import { managementReducer } from "../sub-modules/management/store/reducers/management";
import opportunitiesReducer from "../sub-modules/opportunities/store/reducer";
import signalsReducer from "../sub-modules/signals/store/reducer";

import findAppsReducer from "./find-apps/reducer";

const salesIntelligenceReducer = combineReducers<SalesIntelligenceState>({
    advancedSearchFiltering: advancedSearchFilteringReducer,
    aiAgent: aiAgentReducer,
    appsSearch: appsSearchReducer,
    assignToUsers: assignToUsersReducer,
    common: commonReducer,
    crmEnrichment: crmEnrichmentReducer,
    crmExport: crmExportReducer,
    opportunities: opportunitiesReducer,
    accountOverview: accountOverviewReducer,
    companyAnalysis: companyAnalysisReducer,
    advancedSearch: advancedSearchReducer,
    contactsExport: contactsExportReducer,
    contactsTab: contactsTabReducer,
    management: managementReducer,
    signals: signalsReducer,
    myLists: myListsReducer,
    intent: intentReducer,
    findApps: findAppsReducer,
    leadsSearch: leadsSearchReducer,
    leadsSearchFilters: leadsSearchFiltersReducer,
    teams: teamsReducer,
    quota: quotaReducer,
});

export default salesIntelligenceReducer;
